import { Pipe, PipeTransform } from '@angular/core';
import { Sort } from '@core/bean/sort';
import { Direction } from '@core/bean/direction';

/**
 * 排序使用
 * key：排序关键词
 * order: asc/desc 升序降序
 */
@Pipe({ name: 'advSort' })
export class AdvSortPipe implements PipeTransform {
  transform(dataList: [any], sorts: Array<Sort>) {
    if (!dataList) {
      return dataList;
    }
    return dataList.sort((a, b) => {
      for (let i = 0; i < sorts.length; i++) {
        let sort = sorts[i];
        let flag = 1;
        if (sort.direction == Direction.DESC) {
          flag = flag * (-1);
        }
        if (a[sort.name] > b[sort.name]) {
          return 1 * flag;
        } else if (a[sort.name] < b[sort.name]) {
          return -1 * flag;
        }
      }
      return 0;
    });
  }
}
